<table class="orderline-grid" *ngIf="processedData && processedData.length > 0 && selectedNode">
  <thead>
    <tr>
      <th *ngFor="let c of selectedNode.display">{{c === "Notes" ? "" : c}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of processedData" (click)="onRowClick(r)" [ngClass]="{'selected': checkSelected(r)}">
      <td *ngFor="let c of selectedNode.display">{{c === "Notes" ? r.NoteCount > 0 ? "N" : "" : r[c]}}</td>
    </tr>
  </tbody>
</table>
